import ERROR_MESSAGES from '../libs/errorMessages';

const LOGIN_CONSTANTS = {
  ERROR: ERROR_MESSAGES.LOAD_INFO,
};

export default LOGIN_CONSTANTS;
